import React from "react";
import "./Uncategory.css";
import rangeAttachment from "./Image/RangeAttachmentLinks.jpg";
import RangeForging from "./Image/RangeForgingLinks.jpg";
import Range from "./Image/RangeLinks.jpg";

const Uncategory = () => {
  return (
    <div>
      <div className="uncategoryp">
        <p className="p">Uncategorized</p>
        <div className="p2">
          {/* <p>Swajit Engineering Pvt.Ltd: &gt; Products &gt; Uncategorized</p> */}
        </div>
      </div>

      <div className="uncategory">
        <div className="unimg">
          <figure>
            <img src={rangeAttachment} alt="Range Attachment" />
            <figcaption>Range Attachment Ring</figcaption>
          </figure>
        </div>

        <div className="unimg">
          <figure>
            <img src={RangeForging} alt="Range Attachment" />
            <figcaption>Range Forging Links</figcaption>
          </figure>
        </div>

        <div className="unimg">
          <figure>
            <img src={Range} alt="Range Attachment" />
            <figcaption>Range Ring</figcaption>
          </figure>
        </div>
      </div>
    </div>
  );
};

export default Uncategory;
